import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * @file  pagination/rc-pagination/Pager
 * @author chenyaqiu
 */
import React from 'react';
import classNames from 'classnames';
;
var Pager = function Pager(_ref) {
  var _classNames;
  var onClick = _ref.onClick,
    page = _ref.page,
    rootPrefixCls = _ref.rootPrefixCls,
    active = _ref.active,
    className = _ref.className,
    onKeyPress = _ref.onKeyPress,
    showTitle = _ref.showTitle,
    disabled = _ref.disabled,
    itemRender = _ref.itemRender;
  var prefixCls = "".concat(rootPrefixCls, "-item");
  var cls = classNames(prefixCls, "".concat(prefixCls, "-").concat(page), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), !page), _classNames));
  var handleClick = React.useCallback(function () {
    onClick(page);
  }, [onClick, page]);
  var handleKeyPress = React.useCallback(function (e) {
    onKeyPress(e, onClick, page);
  }, [onKeyPress, onClick, page]);
  return /*#__PURE__*/React.createElement("li", {
    title: showTitle ? page.toString() : '',
    className: cls,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: 0,
    "aria-disabled": disabled
  }, itemRender(page, 'page', /*#__PURE__*/React.createElement("a", {
    rel: "nofollow",
    "aria-disabled": disabled
  }, page)));
};
export default Pager;